const mobMenu = {
  nextLevel: document.querySelectorAll(".jsNextLevel") as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(".jsPrevLevel") as NodeListOf<HTMLElement>,
  advertMenu: document.getElementById('advertMenu') as HTMLElement,
  advertMenuDesktop: document.getElementById('advertMenuDesktop') as HTMLElement,
  advertWrap: document.querySelectorAll('.jsAdvertWrapMobile') as NodeListOf <HTMLElement>,
  advertWrapDesktop: document.querySelectorAll('.jsAdvertWrapDesktop') as NodeListOf <HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,
  

  init() {
    this.setNextLevel()
    this.setPrevLevel()
    this.setImg()
    this.closeAll()
  }, 
  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement
      if (subMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault()          
          subMenu.classList.add("activeClass")        
        })
      }

      this.close.addEventListener('click', (e) => {
        subMenu.classList.remove("activeClass")  
      });
    })
  },

  closeAll() {
    this.close.addEventListener('click', (e) => {

    });
  },
  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement
      if (menu) {
        item.addEventListener("click", () => {                  
          menu?.classList.remove("activeClass")        
        })
      }
      this.close.addEventListener('click', (e) => {
        menu?.classList.remove("activeClass")  
      });
    })
  },

  setImg() {        
                    
    this.advertWrap.forEach(item => {                  
      item.innerHTML += this.advertMenu.innerHTML;
  })     

      this.advertWrapDesktop.forEach(item => {                  
      item.innerHTML += this.advertMenuDesktop.innerHTML;
  })     
        
}
}

export default mobMenu
